jQuery(function($){

    // Key Finding Block
    var key_findings_blocks = document.querySelectorAll('.key-findings-block');
    if(key_findings_blocks){
        Array.from( key_findings_blocks ).forEach(function(block){
        // Main slider
        new Splide( block.querySelector( '.splide.slider' ), {
            type   : 'slide',
            arrows: true,
            pagination: true
        } ).mount();
        })
    }

    // Scroll to the next section 

    var is_scrolling = false;
    var sections = document.querySelectorAll('.scroll-section');

    if( sections ){

        sections = Array.from( sections );
        sections.shift();

        var observer;
        var options = { threshold: 0.25, rootMargin: '100px' };
        
        observer = new IntersectionObserver(handleIntersect, options);

        sections.forEach(function(section){
            observer.observe(section);
        });

    }

    function handleIntersect(entries){

        entries.forEach(
            function(entry){
                if (entry.isIntersecting){
                    var element = entry.target;
                    if( false == is_scrolling ){
                        $('html, body').animate({ scrollTop: $(element).offset().top }, 200, "linear");
                    }
                }
            }
        );
    }

    // Scroll to next slide
    $('.is-style-next-slide a').on('click', function(e){
        e.preventDefault();
        var next = $(this).parents('.scroll-section').next('.scroll-section');

        if( next.length > 0 ){
            is_scrolling = true;
            $('html, body').animate({ scrollTop: $(next[0]).offset().top }, 200, "linear");
            setTimeout( function(){ is_scrolling = false; }, 1000);
        }
    });

    // scroll to previous slide
    $('.is-style-prev-slide a').on('click', function(e){
        e.preventDefault();
        var prev = $(this).parents('.scroll-section').prev('.scroll-section');

        if( prev.length > 0 ){
            is_scrolling = true;
            $('html, body').animate({ scrollTop: $(prev[0]).offset().top }, 200, "linear");
            setTimeout( function(){ is_scrolling = false; }, 1000);
        }
    });

    // Scrolls a tags with anchor links
    $( '.scroll-section a' ).on('click', function(e){

        var target = e.target.hash;

        if( target ){

            var element = document.querySelector(target);

            if( element ){

                is_scrolling = true;

                $('html, body').animate({ 
                    scrollTop: $(element).offset().top
                }, 400, "linear" );

                setTimeout( function(){ is_scrolling = false; }, 1000);

                e.preventDefault();
            }

        }

    })


});